import { routes } from "utilities/routes";

const basePath = process.env.REACT_APP_BASEPATH;

export const orderUrls = {
  orderDetails: (orderAcknowledgementNumber: string): string =>
    `${routes.deliveries.orders.index}/${orderAcknowledgementNumber}`,
  orders: (): string => `${routes.deliveries.orders.index}`,
  shippingDetailDocument: (shippingDetailId: number, shippingDetailDocumentType: number): string =>
    `${basePath}/api/Order/shippingDetailFiles?ShippingDetailId=${shippingDetailId}&DocumentType=${shippingDetailDocumentType}`
};
